<script>
export default {
    name: 'Validation',

    data() {
        return {}
    },
    methods: {
        notEmpty(input) {
            if (input.length == 0 || input.trim().length == 0) {
                return false;
            }

            return true;
        },
        notSelected(input) {
            if (input.length == 0) {
                return false;
            }

            return true;
        },

        minMaxLength(input, min, max) {
            if (input.length < min || input.length > max) {
                return false;
            }

            return true;
        },
        maxLength(input, max) {
            if (input.length > max) {
                return false;
            }

            return true;
        },
        validName(input) {
            var ret = /^[a-zA-Z ]{2,30}$/.test(input);
            if (!(ret)) {
                return false;
            }

            return true;
        },
        validUsername(input) {
            if (!input) {
                return false;
            }
            var ret = /^[0-9a-zA-Z]{3,25}$/.test(input);
            if (!(ret)) {
                return false;
            }

            return true;
        },
        validFolder(input) {
            var ret = /^[-0-9a-zA-Z ]{2,25}$/.test(input);
            if (!(ret)) {
                return false;
            }

            return true;
        },
        validHandle(input) {
            if (!input) {
                return false;
            }
            var ret = /^[0-9a-zA-Z]{3,25}$/.test(input);
            if (!(ret)) {
                return false;
            }

            return true;
        },
        validPassword(input) {
            if (input.length < 8) {
                return false;
            }
            return true;
        },
        validState(input) {
            var ret = /^(([Aa][EeLlKkSsZzRr])|([Cc][AaOoTt])|([Dd][EeCc])|([Ff][MmLl])|([Gg][AaUu])|([Hh][Ii])|([Ii][DdLlNnAa])|([Kk][SsYy])|([Ll][Aa])|([Mm][EeHhDdAaIiNnSsOoTt])|([Nn][EeVvHhJjMmYyCcDd])|([Mm][Pp])|([Oo][HhKkRr])|([Pp][WwAaRr])|([Rr][Ii])|([Ss][CcDd])|([Tt][NnXx])|([Uu][Tt])|([Vv][TtIiAa])|([Ww][AaVvIiYy]))$/.test(input);
            if (!(ret)) {
                return false;
            }

            return true;

        },
        validZip(input) {
            var ret = (input.length <= 9 && /^\d{5}(?:[-\s]\d{4})?$/.test(input));
            if (!(ret)) {
                return false;
            }

            return true;
        },
        validAddress(input) {
            var ret = (/^[a-zA-Z0-9\s,'-.]+$/.test(input));
            if (!(ret)) {
                return false;
            }

            return true;
        },
        validEmail(input) {
            var ret = (input.length <= 128 && /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(input));
            if (!(ret)) {
                return false;
            }
            return true;
        },
        validPhone(input) {
            var ret = (input.length <= 12 && /^[1-9]\d{2}-\d{3}-\d{4}$/.test(input));
            if (!(ret)) {
                return false;
            }
            return true;
        },
        validCard(input) {
            var ret = /^(?:4[0-9]{12}(?:[0-9]{3})?|(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\d{3})\d{11})$/.test(input);
            if (!(ret)) {
                return false;
            }
            return true;
        },
        validCVV(input) {
            var ret = /^[0-9]{3,4}$/.test(input);
            if (!(ret)) {
                return false;
            }
            return true;
        },
        validCardExp(inputMonth, inputYear) {
            if (!inputMonth || !inputYear) {
                return false;
            }

            var d = new Date();

            var currentMonth = d.getMonth() + 1;
            var currentYear = d.getFullYear().toString().substr(-2);
            if (inputMonth != "" && inputYear != "") {
                if (inputMonth >= 13) {
                    return false;
                }
                if (inputYear < currentYear) {
                    return false;
                } else if (inputYear == currentYear) {
                    if (inputMonth <= currentMonth) {
                        return false;
                    }
                }
            }
            return true;
        },
        validDollarAmount(input) {
            var ret = /^[0-9]+(\.[0-9]{1,2})?$/.test(input);
            if (!(ret)) {
                return false;
            }
            return true;
        },

        validInteger(input) {
            if (input.length == 0) {
                return false;
            }

            var ret = /^\d*$/.test(input);
            if (!(ret)) {
                return false;
            }
            return true;
        },

        validCategory(input) {
            var ret = /^[-0-9a-zA-Z ]{2,50}$/.test(input);
            if (!(ret)) {
                return false;
            }

            return true;
        },
    }
}
</script>
